import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox } from '../../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../../components';

const TABLE_COLUMNS = [
  {
    header: 'Reason Name ',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black',
          }}
        >
          {`${row.reason}`}
        </span>
      );
    },
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialReasonMasterDataObj = {
  data: [],
  loading: false
};

export const ReasonMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [reasonNameDataObj, setReasonNameDataObj] = useState(initialReasonMasterDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  console.log(`${lastPathSegment}Read`);
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({ reason: Yup.string().required('Reason Name is required') })),
    defaultValues: { reason: '', default: false },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('reason', selectedRecord.reason);
      setValue('default', selectedRecord.status === 'default');
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/reason-master-update' : '/reason-master-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        reason: formValues.reason,
        status: formValues.default ? 'default' : 'active'
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Reason master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} OPD type master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/reason-master-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Reason master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Reason master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/reason-master-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Reason master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Reason master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setReasonNameDataObj({ loading: true });
    const response = await request('/reason-master-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(item =>
        item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setReasonNameDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setReasonNameDataObj({ loading: false });
    }
  };

  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',

          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Reason Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord()
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn id={"Exit"} variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={2}>
            <Box sx={{ border: '1px solid gray', padding: 2, borderRadius: '8px',width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Reason Name</Typography>
                <TextField
                  name="reason"
                  sx={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  inputProps={{ sx: { fontSize: '1.6rem' } }}
                  placeholder="Enter Reason name"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Default</Typography>
                  <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="default" fontSize={18} />
                </Stack>
              </Stack>
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 1.5 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Reason Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={reasonNameDataObj.data || []}
          loading={reasonNameDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
